import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TextRecordService {
 Base_url =  `${AppSettings.EMAIL_API_ENDPOINT}`;
  textUrl = `${AppSettings.API_ENDPOINT}/${'get-text-file-list'}`;
  keywordPercentageUrl = `${AppSettings.API_ENDPOINT}/${'get-questions-text-file-name'}`;
  textTranscriptUrl = `${AppSettings.API_ENDPOINT}/${'get-file-text-by-file-name'}`;
  textInfoUpdateUrl = `${AppSettings.API_ENDPOINT}/${'update-text-file'}`;
  textInfoDetailUrl = `${AppSettings.API_ENDPOINT}/${'get-topic/1'}`;
  deleteTextTableUrl = this.Base_url+"/text/";
  translateUrl_1 = `${AppSettings.API_ENDPOINT}/${'get-transcription-text'}`;
  translateUrl_2 = `${AppSettings.API_ENDPOINT}/${'translate'}`;
   textDataUrl = this.Base_url+'/text/data';
  constructor(private http: HttpClient) { }

  getTextRecords(data:any){
      return this.http.post(this.textDataUrl, data);
  }

  getTextKeywordPercentage(id:string){
      return this.http.get(`${this.keywordPercentageUrl}/${id}`);
  }

  getTranscript(id:string){
    return this.http.get(`${this.textTranscriptUrl}/${id}`);
  }

  getTextInfo(){
      return this.http.get(this.textInfoDetailUrl);
  }

  updateTextInfo(data:any){
    return this.http.post(this.textInfoUpdateUrl, data);
  }

  deleteTextTable(record_id:any){
    return this.http.delete(this.deleteTextTableUrl+"/"+record_id);
  }

  getTranscriptionOriginalText(id:string){
    return this.http.get(`${this.translateUrl_1}/${id}/text`);
  }

  getTranslatedLanguageData(data:any){
    return this.http.post(this.translateUrl_2, data);
  }

  //  deleteEmailData(id:string){
  //   return this.http.delete(`${this.deleteEmailTableUrl}/${id}`);
  // }
}
